import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ProxyForm } from '@/UI/components/Helpers/ProxyForm';
import { RouterNameEnum } from '@/router/router.types';
import { RouterProperties } from '@/router/routerProperties';
import { appPaginationStore } from '@/store/modules/appPagination';
import { appFiltersStore } from '@/store/modules/appFilters';
import { checkUserRole, getUserData } from '@/router/Lib/helper';
import {AppStateStore} from "@/store/modules/appState";
import {getStudioId} from "@/UI/lib/state";

@Component
export class ProxyDataForm extends mixins(ProxyForm) {
    @Prop() source!: string;
    constructor() {
        super();
    }
    requestProcessing: boolean = false;
    filters = appFiltersStore;

    getSource(source: string): string {
        let result = source;
        console.log('RouterProperties source -'+source )
        //TODO:: обязательно указать source
        if (source === RouterProperties.products_mass) result = 'products';
        if (source === RouterProperties.products_archived) result = 'products';
        if (source === RouterProperties.stores) result = 'warehouse';
        if (source === RouterProperties.clients) result = 'clients';
        if (source === RouterProperties.services) result = 'services';
        if (source === RouterProperties.servicesCategory) result ='servicesCategory';
        if (source === RouterProperties.oldServicesCategory) result ='servicesCategory';
        if (source === RouterProperties.oldPartnerServices) result ='servicesCategory';
        if (source === RouterProperties.loyaltyCert)  result='loyaltyCert';
        //if (source === RouterProperties.servicesCategory) result='servicesCategory'
        return result;
    }

    //TODO::установка значения фильта из параметров из маршрута
    setRulesRouteFilter(source: string, filter:any):any {
        console.log('setRulesRouteFilter method ---- ')

        if (source === RouterProperties.clientVisits) {
            filter['client_id'] = Number(this.$route.params.id)
        }
        if (source === RouterProperties.clientsAccountsHistory) {
            console.log('*** Set filter from route '+ source)
            filter['client_id'] = Number(this.$route.params.id)
        }
        if (source === RouterProperties.clientDocuments) {
            filter['client_id'] =  Number(this.$route.params.id)
        }
        if (source === RouterProperties.ClientDetailNotes) {
            filter['client_id'] =  Number(this.$route.params.id)
        }

        if ((source === RouterProperties.products) && (Number(Vue.router.currentRoute.params['idCategory'])!==0)) {
            //&& (Number(Vue.router.currentRoute.params['idCategory'])!==0)
            filter['category_id'] = Vue.router.currentRoute.params['idCategory']
        } /*else
        if ((source === RouterProperties.products) && (Number(Vue.router.currentRoute.params['idCategory'])===0)) {
            filter['category_id'] = ''
        }*/
        return filter;
    }

    setFilterValues(index:string, value:string, filter:any):void {
        //filter[index] = String(value)
        filter.push({index:value})
    }

    setStudioID(filter: any): void {
        if(!filter.salon_id)
        {
            filter.salon_id = this.$store.state.salon_id;
        }
    }


    @Watch ('$store.state.appState.sendProxyWithParam',{ immediate: true })
    async ProxySubmitParam(value: string):Promise<void> {
        if (value) {
            console.log('Proxy event' )
            AppStateStore.setProxyWithParam(false)
            await this.getData(value)
        }
    }
    @Watch('$store.state.appState.sendProxy', { immediate: true })
    async ProxySubmit(value: boolean): Promise<void> {
        if (value) {
            console.log('Proxy event')
            AppStateStore.setProxy(false)
            await this.getData()
        }
    }

    async getData(src?:string):Promise<void> {
        this.requestProcessing = true;
        const Role = checkUserRole();
        const UserData = getUserData();
        const sourceDta =  src!==undefined ? src : this.$props.source


        console.log('Source Data ', this.$props.source)

        // active: this.active == '1' ? true : false,
        //const sourceDta = this.$props.source
        //!= null ? value : 'default value';


        if (this.$route.params.filter !== undefined && this.$route.params.filter.length > 2) {
            const filter = JSON.parse(this.$route.params.filter);
            /*if (Role === 'owner') {
                filter.salon_id = UserData.studios;
            }*/
            this.setRulesRouteFilter(sourceDta, filter)
            await appFiltersStore.setFiltersSource({
                source: sourceDta,
                data: filter,
            });
        }
        if (this.$route.params.page !== undefined) {
            try {
                const filter = JSON.parse(this.$route.params.filter);
                const source = this.getSource(sourceDta);

                this.setRulesRouteFilter(sourceDta, filter)

                if (Role === 'owner') {
                    filter.salon_id = UserData.studios;
                }

                /*if (source === RouterProperties.products_mass) source = 'products'
                if (source === RouterProperties.products_archived) source ='products'
                if (source === RouterProperties.stores) source ='warehouse'*/

                console.log('Parse data from -', source);

                if (this.$route.params.filter.length > 2) {
                    await this.$store.dispatch(source + '/fetchAll', {
                        skip: this.calcSkipPage(Number(this.$route.params.page)),
                        limit: this.AppPageParams.pageSize,
                        filter: filter,
                    });
                } else {
                    await this.$store.dispatch(source + '/fetchAll', {
                        skip: this.calcSkipPage(Number(this.$route.params.page)),
                        limit: this.AppPageParams.pageSize,
                        filter: {
                            salon_id: UserData.studios,
                        }
                    });
                }
                await this.$store.dispatch('appPagination/setTotal', Number(this.$route.params.total));
                await this.$store.dispatch('appPagination/setCurrent', Number(this.$route.params.page));
            } catch (e) {
                console.log('Proxy DataForm set Pagination Error -' + e);
            }
        } else {
            try {
                const source = this.getSource(sourceDta);

                console.log('Proxy source -'+ source)
                if (source === undefined) {
                    console.log('!!! Внимание установите источник в getSource')
                }

                /* const filter = new (class {
                    salon_id: number;
                    client_id: number;
                    constructor() {
                        this.salon_id = 0;
                        this.client_id = 0
                    }
                })(); */
                let filter:[]=[];

                filter = this.setRulesRouteFilter(source, filter)
                this.setStudioID(filter);
                if (Role === 'owner') {
                    //filter['salon_id'] = UserData.studios;
                    // Эта функция записывает в массив, фильтр предполагает объект. Не понял для чего. Ошибки падают.
                    //this.setFilterValues('salon_id',UserData.studios,filter)

                    await this.$store.dispatch(source + '/fetchAll', {
                        limit: this.AppPageParams.pageSize,
                        filter:  filter,
                    });
                    await this.$store.dispatch('appPagination/setCurrent', 1);
                }
                else {
                    if(source)
                    {
                        await this.$store.dispatch(source + '/fetchAll', {
                            limit: this.AppPageParams.pageSize,
                            filter: filter,
                        });
                        await this.$store.dispatch('appPagination/setCurrent', 1);
                    }
                }
            } catch (e) {
                console.log('Proxy DataForm dispatch data error -' + e);
            }
            try {
                console.log('ProxyDataForm set source ')
                
                if (this.$props.source === RouterProperties.salons) {
                    await this.$store.dispatch('appPagination/setTotal', Number(this.$store.state.salons.salons.total));
                }
                if (this.$props.source === RouterProperties.clients) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.clients.clients.total)
                    );
                }
                if (this.$props.source === RouterProperties.stores) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.warehouse.warehouse.total)
                    );
                }
                if (this.$props.source === RouterProperties.products) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.products.products.total)
                    );
                }
                if (this.$props.source === RouterProperties.products_mass) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.products.products.total)
                    );
                }
                if (this.$props.source === RouterProperties.products_archived) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.products_archived.products_archived.total)
                    );
                }
                if (this.$props.source === RouterProperties.operations) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.operations.operations.total)
                    );
                }
                if (this.$props.source === RouterProperties.settingsUser) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.settingsUser.users.total)
                    );
                }
                if (this.$props.source === RouterProperties.financeOperations) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.financeOperations.items.total)
                    );
                }
                if (this.$props.source === RouterProperties.loyaltyCert) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.loyaltyCert.loyaltyCerts.total)
                    );
                }
                if (this.$props.source === RouterProperties.loyaltyCertType) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.loyaltyCertType.loyaltyCertTypes.total)
                    );
                }

                if (this.$props.source === RouterProperties.loyaltySubscription) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.loyaltySubscription.loyaltySubscriptions.total)
                    );
                }
                if (this.$props.source === RouterProperties.loyaltySubscriptionType) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.loyaltySubscriptionType.loyaltySubscriptionTypes.total)
                    );
                }
                if (this.$props.soure === RouterProperties.clientDocuments) {
                    //TODO::error Add store
                    await this.$store.dispatch('appPagination/setTotal',0

                    )
                }
                if (this.$props.source === RouterProperties.clientVisits) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.visits.visits.total)
                    );
                }
                if (this.$props.source === RouterProperties.clientsAccountsHistory) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.clientsAccountsHistory.items.total)
                    );
                }
                if (this.$props.source === RouterProperties.counterparties) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.counterparties.counterparties.total)
                    );
                }
                if (this.$props.source === RouterProperties.clientsaccountsAll) {

                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.clientsAccountsAll.items.total)
                    );
                }
                if (this.$props.source === RouterProperties.clientNotes) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.visits.visits.total)
                    );
                }
                if (this.$props.source === RouterProperties.services) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.services.services.total)
                    );
                }

                if (this.$props.source === RouterProperties.servicesCategory) {
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.servicesCategory['serviceCategory']['total'])
                    );
                }

                if (this.$props.source === RouterProperties.oldServicesCategory) {
                    
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.servicesCategory['serviceCategory']['total'])
                    );
                }

                if (this.$props.source === RouterProperties.oldPartnerServices) {
                    
                    await this.$store.dispatch(
                        'appPagination/setTotal',
                        Number(this.$store.state.servicesCategory['serviceCategory']['total'])
                    );
                }

            } catch (e) {
                console.log('Proxy DataForm set Pagination Error -' + e);
            }
        }
        this.requestProcessing = false;
    }

    async created(): Promise<void> {
        await this.getData()
    }
    async handleTableChange(pagination: any, filters: any, sorter: any): Promise<void> {
        console.log(pagination,'=======------==========')
        const page_size = pagination.pageSize
        const Role = checkUserRole();
        const UserData = getUserData();

        this.tableLoad = false;
        let routeName = '';
        let filter = {};

        if (this.$props.source === RouterProperties.salons) {
            routeName = RouterNameEnum.SalonsPage;
            filter = appFiltersStore.salons;
        }
        if (this.$props.source === RouterProperties.clients) {
            routeName = RouterNameEnum.ClientsPage;
            filter = appFiltersStore.clients;
        }
        if (this.$props.source === RouterProperties.counterparties) {
            routeName = RouterNameEnum.CounterpartiesPage;
            filter = appFiltersStore.counterparties;
        }
        if (this.$props.source === RouterProperties.stores) {
            routeName = RouterNameEnum.StoresPage;
            filter = appFiltersStore.stores;
        }
        if (this.$props.source === RouterProperties.products) {
            routeName = RouterNameEnum.StoresProductsPage;
            filter = appFiltersStore.products;
        }
        if (this.$props.source === RouterProperties.products_mass) {
            routeName = RouterNameEnum.StoresProductsMassEditPage;
            filter = appFiltersStore.products;
        }
        if (this.$props.source === RouterProperties.products_archived) {
            routeName = RouterNameEnum.StoresProductsPageArchived;
            filter = appFiltersStore.products;
        }
        if (this.$props.source === RouterProperties.operations) {
            routeName = RouterNameEnum.StoreOperationsPage;
            filter = appFiltersStore.operations;
        }

        if (this.$props.source === RouterProperties.settingsUser) {
            routeName = RouterNameEnum.SettingsUsersPage;
            filter = appFiltersStore.settingsUser;
        }
        if (this.$props.source === RouterProperties.financeOperations) {
            routeName = RouterNameEnum.FinanceOperationsPage;
            filter = appFiltersStore.settingsUser;
        }
        if (this.$props.source === RouterProperties.loyaltyCert) {
            routeName = RouterNameEnum.LoyaltyCertPage;
            filter = appFiltersStore.loyaltyCerts;
        }
        if (this.$props.source === RouterProperties.loyaltyCertType) {
            routeName = RouterNameEnum.LoyaltyCertTypePage;
            filter = appFiltersStore.loyaltyCertsType;
        }

        if (this.$props.source === RouterProperties.loyaltySubscription) {
            routeName = RouterNameEnum.LoyaltySubscriptionPage;
            filter = appFiltersStore.loyaltySubscription;
        }

        if (this.$props.source === RouterProperties.loyaltySubscriptionType) {
            routeName = RouterNameEnum.LoyaltySubscriptionTypePage;
            filter = appFiltersStore.loyaltySubscription;
        }

        if (this.$props.source === RouterProperties.clientDocuments) {
            routeName =  RouterNameEnum.ClientDetailDocuments;
            filter = appFiltersStore.clientDocoments
        }
        if (this.$props.source === RouterProperties.clientVisits) {
            routeName = RouterNameEnum.ClientDetailHistoryPage;
            filter = appFiltersStore.clientVisits
        }
        if (this.$props.source === RouterProperties.clientsAccountsHistory) {
            routeName = RouterNameEnum.ClientAccountsPage;
            filter = appFiltersStore.clientsAccountsHistory
        }

        if (this.$props.source === RouterProperties.clientsaccountsAll) {
            routeName = RouterNameEnum.ClientsAccountsAllPage;
            filter = appFiltersStore.clientsAccountsAll;
        }
        if (this.$props.source === RouterProperties.clientNotes) {
            routeName = RouterNameEnum.ClientDetailNotesPage;
            filter = appFiltersStore.clientsNotes;
        }
        if (this.$props.source === RouterProperties.services) {
            routeName = RouterNameEnum.ServicesPage;
        }

        if (this.$props.source === RouterProperties.servicesCategory) {
            routeName = RouterNameEnum.ServicesPage
        }
        /*if (this.$props.source === RouterProperties.se) {

        }*/



        const source = this.getSource(this.$props.source);
        //TODO::Добавляем к фильтру автоматически salon_id
        if (Role === 'owner') {
            if (filter) {
                // @ts-ignore
                filter.salon_id = UserData.studios;
            }
        }

        const filterData = JSON.stringify(filter);
        //setRouteFilter(routeName, filterData, false);

        await Vue.router.push({
            name: routeName,
            params: { page: pagination.current, page_size: page_size, total: pagination.total, filter: filterData },
        }).catch((e)=>{console.error(e)});
        try {
            console.log('Proxy Data --- ****');
            //TODO::Глобальный Обработчик роли пользователя

            await this.$store.dispatch(source + '/fetchAll', {
                skip: this.calcSkip(pagination),
                limit: pagination.pageSize,
                filter: filter,
            });
            appPaginationStore.setCurrent(pagination.current);
            appPaginationStore.PageParams.pageSize = page_size;
        } catch (e) {
            console.log('Pagination | Parse data error ');
        }

        this.tableLoad = true;
    }

    async fetch(): Promise<void> {
        /*const Role = checkUserRole();
        const UserData = getUserData();*/
        const filter = new (class {
            salon_id: number | null;
            constructor() {
                this.salon_id = null;
            }
        })();

        filter.salon_id = getStudioId(this);



        /*if (Role == 'admin') {
            filter.salon_id = this.$store.state.salon_id;
        } else if (UserData && UserData.studios) {
            filter.salon_id = UserData.studios;
        }*/

        await this.$store.dispatch(this.getSource(this.$props.source) + '/fetchAll', {
            limit: this.AppPageParams.pageSize,
            filter: filter,
        });

        await this.$store.dispatch('appPagination/setCurrent', 1);
    }

    @Watch('$store.state.salon_id', { immediate: false })
    async onSalonChange(): Promise<void> {
        await this.getData();
    }
}